var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pb-16 pb-md-20"
  }, _vm._l(_vm.classifications, function (_ref) {
    var term = _ref.term,
        desc = _ref.desc,
        list = _ref.list,
        type = _ref.type;
    return _c('v-row', {
      key: term.en,
      staticClass: "mt-16 mt-md-20",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "5",
        "md": "12",
        "lg": "5"
      }
    }, [_c('div', {
      staticClass: "mb-8 mb-sm-0 mb-md-8 mb-lg-0"
    }, [_c('div', {
      staticClass: "d-inline-block d-sm-block font-size-14 font-size-md-16 font-weight-bold primary--text"
    }, [_vm._v(_vm._s(term.ko))]), _c('div', {
      staticClass: "d-inline-block d-sm-block font-size-14 font-weight-light grey-68--text pl-6 pl-sm-0"
    }, [_vm._v(_vm._s(term.en))])])]), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "7",
        "md": "12",
        "lg": "7"
      }
    }, [type == _vm.NULL.value ? [_c('span', {
      staticClass: "font-size-14"
    }, [_vm._v("데이터가 없습니다.")])] : _vm._e(), type == _vm.DESC.value ? [_c('span', {
      staticClass: "font-size-14"
    }, [_vm._v(_vm._s(desc))])] : _vm._e(), type == _vm.LIST.value ? [_c('v-row', {
      staticClass: "row--xx-small",
      staticStyle: {
        "pointer-events": "none"
      }
    }, _vm._l(list, function (_ref2) {
      var term = _ref2.term,
          isIt = _ref2.isIt;
      return _c('v-col', {
        key: term,
        attrs: {
          "cols": list.length > 2 ? 4 : 12
        }
      }, [isIt ? [_c('v-chip', {
        staticClass: "rounded-0 w-100 pa-0 justify-center",
        staticStyle: {
          "height": "26px"
        },
        attrs: {
          "outlined": "",
          "color": "grey-cb",
          "text-color": "primary"
        }
      }, [_vm._v(_vm._s(term))])] : [_c('v-chip', {
        staticClass: "rounded-0 w-100 pa-0 justify-center",
        staticStyle: {
          "height": "26px"
        },
        attrs: {
          "color": "grey-ef",
          "text-color": "grey"
        }
      }, [_vm._v(_vm._s(term))])]], 2);
    }), 1)] : _vm._e()], 2)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }